"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeAutoScrollProvider = void 0;
const Col_1 = require("@amzn/atoz-web/Col");
exports.NativeAutoScrollProvider = Col_1.Col;
